
import React, { Component, PropTypes } from 'react';
import Select from 'react-select';
import Translate from '../layout/Translate';
import Price from '../layout/Price';

export default class Pay extends Component {



    saveClient() {
       //console.log(this.props.order);

        this.props.actions.saveClient(this.props.order.id, {

        });
    }


    componentDidUpdate () {
        if (this.props.order.chronopay_info && this.props.order.chronopay_info.result) {
            //console.info('update');
            this.inputElement.click();
        }
    }

    setPayMode(config) {

        this.props.actions.setPayMode(config);
    }

    getLink() {

        this.props.actions.getProcessingLink({
            order: this.props.order.props.order.id,
            type: this.props.order.type,
            prepayment: this.props.order.prepayment,
            payment: this.props.order.payment,
            currency: this.props.order.currency
        });
    }


    getNumEnding(iNumber, aEndings)
    {
        var sEnding, i;
        iNumber = iNumber % 100;
        if (iNumber>=11 && iNumber<=19) {
            sEnding=aEndings[2];
        }
        else {
            i = iNumber % 10;
            switch (i)
            {
                case (1): sEnding = aEndings[0]; break;
                case (2):
                case (3):
                case (4): sEnding = aEndings[1]; break;
                default: sEnding = aEndings[2];
            }
        }
        return sEnding;
    }

    render () {
        let endings = [<Translate slug="tour__day-1" />, <Translate slug="tour__day-2-4" />, <Translate slug="tour__day-5-0" />];

        const { departure } = this.props.order;
        const order = this.props.order;
        const tour = this.props.tour;
        const user = this.props.user;
        const payMods = [
            {payment: 1, prepayment: 0, label: 'Оплата 100%'},
            {payment: 0, prepayment: 1, label: 'Предоплата 30%'}
        ];
        
        return (
            <div>

                <div className="form__row">
                    <table className="table order__table services">
                        <tbody>
                        <tr className=" services__row">
                            <td className=" services__col"><span className="services__title">{tour.title}</span></td>


                            <td className="services__col table__title_align_center">
                                <span className="services__duration">{tour.days_count}  {this.getNumEnding(tour.days_count, endings)}
                                </span>  {departure.formated_start_date} &mdash; {departure.formated_end_date}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2" className="">
                                <table className="table">
                                    <tbody>

                                    <tr>
                                        <td colSpan="6" rowSpan="3" className="table__col table__col_bottom">
                                            <div className="form__note">
                                                <Translate slug="order__summary__bill" /> № 38/2401 от 20.01.2016<br/>
                                                <Translate slug="order__summary__manager" />: Pavel Ageychenko
                                            </div>
                                        </td>
                                        <td className="table__col table__col_align_right table__col_bottom"><Translate slug="order__summary__in-total" />:</td>
                                        <td className="table__col table__col_align_right table__col_bottom">
                                            <Price price={order.props.order.processing.total_price} currency={order.props.order.processing.currency} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="table__col table__col_align_right table__col_bottom"><Translate slug="order__summary__discount" /> 10%:</td>
                                        <td className="table__col table__col_align_right table__col_bottom">-<Price price={0} currency={departure.currency_id} /> Р</td>
                                    </tr>
                                    <tr>
                                        <td className="table__col table__col_align_right table__col_bottom"><Translate slug="order__summary__in-total" />:</td>
                                        <td className="table__col table__col_align_right table__col_bottom"><span className="table__info_bold">
                                            <Price price={order.props.order.processing.total_price} currency={order.props.order.processing.currency} />
                                        </span></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        </tbody>

                    </table>
                </div>

                <h3 className="form__title">
                    <Translate slug="order__pay__type" />
                </h3>
                <p className="form__info">
                    <Translate slug="order__prepay" /> <Price price={order.props.order.processing.total_price*0.3} currency={order.props.order.processing.currency} /> <Translate slug="order__or-pay" /> <Price price={order.total} currency={order.props.order.processing.currency} /><br/>

                    <Translate slug="order__redirect" />
                </p>
                {false &&
                    <div className="form__row">
                        <div className="">
                            <select className="form__select form__control form__control_center">
                                <option>Банковская карта</option>
                            </select>
                        </div>
                    </div>
                }
                <div className="form__row">
                    <div className="">


                        <Select
                            className="form__select form__control_center"
                            name="form-field-name"
                            value={this.props.order.payment}
                            options={payMods}
                            valueKey="payment"
                            onChange={this.setPayMode.bind(this)}
                        />
                    </div>
                </div>

                <h3 className="form__title">
                    <Translate slug="order__conditions__title" />
                </h3>
                <div className="form__row">

                    <div className="form__col form__col_12">
                        <textarea className="form__control form__control_auto">

                        </textarea>
                    </div>
                </div>

                <div className="form__row">

                    <div className="form__col form__col_center form__col_12">
                        <label><input type="checkbox"/> <Translate slug="order__conditions__accepted" /></label>
                    </div>
                </div>
                <div className="form__buttons">
                    {(this.props.order.chronopay_info  && this.props.order.chronopay_info.result && this.props.order.chronopay_info.result.link) &&
                    <form action={this.props.order.chronopay_info.result.link} method="post">
                        {Object.keys(this.props.order.chronopay_info.result.params).map((key) =>

                            <input type="hidden" key={key} name={key} value={this.props.order.chronopay_info.result.params[key]} />
                        )}
                        <input ref={input => this.inputElement = input} type="submit" style={{display: 'none'}} value="Осуществить платеж"/>
                    </form>
                    }
                    {!(this.props.order.chronopay_info && this.props.order.chronopay_info.result && this.props.order.chronopay_info.result.link) &&
                        <input onClick={this.getLink.bind(this)}
                               className="form__button form__button_success form__button_large" type="button"
                               value="Осуществить платеж"/>
                    }
                    {(this.props.order.chronopay_info  && this.props.order.chronopay_info.result && this.props.order.chronopay_info.result.link) &&
                        <input  className="form__button form__button_success form__button_large form__button_fetching" type="button" value="Осуществить платеж"/>
                    }
                </div>
            </div>
        );
    }
}














// WEBPACK FOOTER //
// ./src/common/components/order/Pay.js